import React from 'react'
import { withRouter } from "react-router-dom";
import FormComponent, { FormOp, Validators } from '../../../components/form/FormOps';

class CpacValor extends FormComponent {

  componentDidMount() {
    this.formConfig(
      { defaultUrl: 'cpacvalor/one', saveUrl: 'cpacvalor/save', backUrl: '/Catalogo/CpacValores' },
      FormOp.Group([
        FormOp.Field('text', 'rangoini', 'Rangoini', '', [Validators.required], 6),
        FormOp.Field('text', 'cpac', 'CPAC', '', [Validators.required], 6),
      ],
        ['Guardar'], 'CPAC'), this.formData)

    if (this.props.match.params.id)
      this.loadFormPreds(this.props.match.params.id)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(CpacValor);